import React from 'react'
import { useNavigate } from 'react-router-dom'

const LogoEchoSystem = ({ tenantUsername }) => {
  const navigate = useNavigate()
  const tenant = tenantUsername || window.location.pathname.split('/').filter(Boolean)[0]
  const ticketsUrl = `/${tenant || ''}/tickets`

  const handleNavigate = (event) => {
    event.preventDefault()
    navigate(ticketsUrl)
  }

  return (
    <a
      className="flex items-center justify-center"
      href={ticketsUrl}
      onClick={handleNavigate}
      aria-label="Support Tickets"
      title="Support Tickets"
    >
      <img src="/logo.png" className="w-6" alt="Absat ERP" />
    </a>
  )
}

export default LogoEchoSystem
